import { Phone, Siren, Clock, MapPin } from "lucide-react";
import QuoteForm from "@/components/QuoteForm";
import { FadeUp, Eyebrow } from "@/components/Reveal";
import { SITE, REGIONS } from "@/data/site";

export default function Contact() {
  return (
    <main className="pt-12 md:pt-16" data-testid="contact-page">
      <section className="relative overflow-hidden bg-gradient-to-b from-brand-paper to-white pb-20 md:pb-28">
        <div className="container-x relative">
          <Eyebrow className="mb-6 inline-flex items-center gap-3">
            <span className="h-px w-10 bg-brand-red" /> Contact Fusion Glass
          </Eyebrow>
          <FadeUp>
            <h1 className="max-w-3xl font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
              Request your <span className="text-brand-red">free quote</span>
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
              Tell us a few details about your job and we'll come back with a clear, no-obligation price -
              usually the same day. For cracked or broken glass, call us straight away.
            </p>
          </FadeUp>

          <div className="mt-14 grid gap-10 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <FadeUp>
                <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-[0_24px_70px_rgba(16,24,40,0.12)] sm:p-8" data-testid="contact-form-panel">
                  <QuoteForm />
                </div>
              </FadeUp>
            </div>

            <div className="space-y-4 lg:col-span-5">
              <FadeUp delay={0.1}>
                <a href={`tel:${SITE.phoneMain}`} className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-6 transition-colors hover:border-brand-red/50" data-testid="contact-call-btn">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-red/10">
                    <Phone className="h-6 w-6 text-brand-red" />
                  </span>
                  <div>
                    <p className="font-display text-xl font-extrabold text-slate-900">{SITE.phoneMainDisplay}</p>
                    <p className="text-xs text-slate-500">{SITE.hours}</p>
                  </div>
                </a>
              </FadeUp>
              <FadeUp delay={0.15}>
                <a href={`tel:${SITE.phoneEmergency}`} className="flex items-center gap-4 rounded-2xl border-2 border-brand-red/20 bg-brand-red/[0.04] p-6 transition-colors hover:border-brand-red/60" data-testid="contact-emergency-btn">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-red text-white">
                    <Siren className="h-6 w-6" />
                  </span>
                  <div>
                    <p className="font-display text-xl font-extrabold text-slate-900">{SITE.phoneEmergencyDisplay}</p>
                    <p className="text-xs text-slate-500">Calls available 24/7 for emergency glass</p>
                  </div>
                </a>
              </FadeUp>
              <FadeUp delay={0.2}>
                <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="contact-hours">
                  <div className="mb-4 flex items-center gap-3">
                    <Clock className="h-5 w-5 text-brand-red" />
                    <h2 className="font-display text-base font-extrabold text-slate-900">Opening hours</h2>
                  </div>
                  <ul className="space-y-1.5 text-sm text-slate-600">
                    <li className="flex justify-between"><span>Monday - Friday</span><span className="font-semibold text-slate-900">7am - 7pm</span></li>
                    <li className="flex justify-between"><span>Saturday</span><span className="font-semibold text-slate-900">7am - 7pm</span></li>
                    <li className="flex justify-between"><span>Sunday</span><span className="text-slate-400">Closed</span></li>
                  </ul>
                </div>
              </FadeUp>
              <FadeUp delay={0.25}>
                <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="contact-areas">
                  <div className="mb-4 flex items-center gap-3">
                    <MapPin className="h-5 w-5 text-brand-red" />
                    <h2 className="font-display text-base font-extrabold text-slate-900">Service areas</h2>
                  </div>
                  <p className="text-xs leading-loose text-slate-500">
                    {REGIONS.map((r) => r.name).join(" · ")} - and every suburb in between.
                  </p>
                </div>
              </FadeUp>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
